const footerTemplate = `
<footer role="contentinfo">
    <div class="container">
        <div class="row" ng-if="accu !== null">
            <div class="col-md-3 col-md-push-9">
                <footer-contact
                    accu-customization="accuCustomization"
                    style-env="styleEnv"
                    site-contact-info="siteContactInfo"
                    current-language="siteContactInfo.selectedLanguage"
                    is-authenticated="isAuthenticated"></footer-contact>
                <div class="footer-partnership-logo">
                    <span translate="footer.partnership"></span>
                    <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" alt="{{ 'footer.logoAlt' | translate }}">
                </div>
                <social-links social-networks="footer.socialMedia" watch-depth="reference"></social-media>
                <div ng-if="!isAuthenticated" class="broker-check">
                    <a href="{{footer.brokerCheck}}" target="_blank">
                        <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" alt="FINRA's BrokerCheck">
                    </a>
                </div>
            </div>
            <div class="col-md-9 col-md-pull-3">
                <footer-disclosure-info disclosures="footer.disclosures" template-values="{urlDomain:styleEnv, year:currentYearForFooter}" watch-depth="reference"></footer-disclosure-info>
                <footer-disclosure-links links="footer.docs" watch-depth="reference"></footer-disclosure-links>
            </div>
        </div>
    </div>
</footer>
`;
export default footerTemplate;
